import { render } from "./RepoDetailView.vue?vue&type=template&id=2f1add38&scoped=true"
import script from "./RepoDetailView.vue?vue&type=script&lang=js"
export * from "./RepoDetailView.vue?vue&type=script&lang=js"

import "./RepoDetailView.vue?vue&type=style&index=0&id=2f1add38&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1add38"]])

export default __exports__